class AdminSettingsPoliciesSchedulingController {
  constructor(PoliciesModel, PoliciesStoreService, FlashService) {
    this.PoliciesModel = PoliciesModel;
    this.PoliciesStoreService = PoliciesStoreService;
    this.FlashService = FlashService;
    this.loading = true;
    this.busy = true;
    this.policies = {
      scheduling: { id: 0, policymeta: {} },
    };

    this.processPolicy = this.processPolicy.bind(this);

    const schedulingPolicy = PoliciesStoreService.getPolicy("scheduling");
    if (schedulingPolicy) {
      const policyMeta = { ...schedulingPolicy.policymeta };
      policyMeta.id = schedulingPolicy.id;
      // Schools created before this policy existed have no row yet; default
      // it so the required select doesn't block saving.
      policyMeta.lock_calendar_when_roadmap_complete =
        policyMeta.lock_calendar_when_roadmap_complete || "N";
      this.policies.scheduling = {
        id: schedulingPolicy.id,
        policymeta: policyMeta,
      };
    }
    this.loading = false;
    this.busy = false;
  }

  processPolicy(isValid) {
    if (isValid) {
      this.busy = true;
      const payload = this.policies.scheduling.policymeta;
      this.PoliciesModel.update(payload).then((response) => {
        this.busy = false;
        this.FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        this.PoliciesStoreService.writePolicy("scheduling", payload);
      });
    } else {
      this.FlashService.setMessage({
        type: "error",
        message: "All fields are required.",
      });
    }
  }
}
AdminSettingsPoliciesSchedulingController.$inject = [
  "PoliciesModel",
  "PoliciesStoreService",
  "FlashService",
];
export default AdminSettingsPoliciesSchedulingController;
